import React from 'react';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowRight, Shield, MapPin, Lock, Mail } from 'lucide-react';
export function ResourcesPage() {
  const guides = [{
    id: 'crisis-response',
    title: 'Crisis Response Guide',
    description: 'Something suspicious just happened. Get calm, step-by-step guidance for scam calls, unauthorized charges, account takeovers, identity theft, and more.',
    tag: 'Emergency Guide',
    tagColor: 'text-red-700 bg-red-100',
    link: '/crisis-help',
    illustration: <div className="w-full h-full bg-gradient-to-br from-[#fff1f1] to-[#ffe4e4] flex items-center justify-center" data-id="element-5075" data-mp="2t6le2l4k3yec">
          <AlertTriangle size={64} className="text-red-600" data-id="element-5076" data-mp="wcrnevzae3a8" />
        </div>
  }, {
    id: 'ca-privacy',
    title: "California Resident's Guide to Privacy & Opt-Out",
    description: 'Learn how to exercise your CCPA rights, use the new DROP tool to delete your data from brokers, and enable OOPS for automatic opt-outs.',
    tag: 'Privacy & Opt-Out',
    tagColor: 'text-[#631bb7] bg-[#f3e8ff]',
    link: '/resources/ca-guide',
    illustration: <div className="w-full h-full bg-gradient-to-br from-[#f5f0ff] to-[#ede0ff] flex items-center justify-center p-8" data-id="element-5077" data-mp="2p4nw85n7nt1i">
          <img src="https://cdn.magicpatterns.com/uploads/rEBPBLjGsXRNeHWosHkCNx/Gemini_Generated_Image_j7hwgij7hwgij7hw.png" alt="California Map" className="w-full h-full object-contain drop-shadow-md" data-id="element-5078" data-mp="3cu8qvlsq8eqm" />
        </div>
  }, {
    id: 'spam-guide',
    title: 'Reducing Spam and Junk Mail',
    description: 'Push back against unwanted emails, texts, calls, and physical mail using tools you already have on your phone or computer.',
    tag: 'Spam & Junk',
    tagColor: 'text-[#01ced1] bg-[#e0fafa]',
    link: '/resources/spam-guide',
    illustration: <div className="w-full h-full bg-gradient-to-br from-[#e0fafa] to-[#c5f5f5] flex items-center justify-center" data-id="element-5079" data-mp="9asu8ozlpit8">
          <Mail size={64} className="text-[#01ced1]" data-id="element-5080" data-mp="4aombncrdwem" />
        </div>
  }, {
    id: 'family-safety',
    title: 'Family Digital Safety Plan',
    description: 'A comprehensive framework for setting up parental controls, managing screen time, and having constructive conversations about online safety with your kids.',
    tag: 'Family Safety',
    tagColor: 'text-blue-700 bg-blue-100',
    link: '#',
    illustration: <div className="w-full h-full bg-gradient-to-br from-[#eff6ff] to-[#dbeafe] flex items-center justify-center" data-id="element-5081" data-mp="3ho0210vb28qh">
          <Shield size={64} className="text-blue-600" data-id="element-5082" data-mp="38penrhwv9fvi" />
        </div>
  }];
  return <div className="min-h-screen w-full bg-white font-sans flex flex-col" data-id="element-5083" data-mp="33qtnjihm6w72">
      <TopBar data-id="element-5084" data-mp="33sxopso4ph3n" />
      <Header data-id="element-5085" data-mp="1j8j4dpw4d65d" />

      {/* Hero Section */}
      <section className="bg-[#1a0647] text-white py-20 px-6 text-center" data-id="element-5086" data-mp="1j7r78amvj0cz">
        <div className="max-w-4xl mx-auto" data-id="element-5087" data-mp="1o742njrt9fr6">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-5088" data-mp="1o5ss913v19r3">
            <span className="text-white" data-id="element-5089" data-mp="1sail0h38287s">Caveo </span>
            <span className="text-[#b063ff]" data-id="element-5090" data-mp="1x8201j7qup0s">Resources</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-5091" data-mp="1x67notajg58b">
            Practical guides to help you and your family stay safe, informed,
            and in control online.
          </p>
        </div>
      </section>

      {/* Featured Guides Section */}
      <section className="py-16 md:py-24 px-6 md:px-12 bg-gray-50 flex-grow" data-id="element-5092" data-mp="19herqwtx1xdp">
        <div className="max-w-7xl mx-auto" data-id="element-5093" data-mp="1ea7tdbu38plk">
          <h2 className="text-2xl md:text-3xl font-bold text-[#111111] mb-10" data-id="element-5094" data-mp="gu22ug0a9dh8">
            Featured Guides
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-5095" data-mp="lsn2oebmhv55">
            {guides.map(guide => <Link key={guide.id} to={guide.link} className="group bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col h-full no-underline" data-id="element-5096" data-mp="2ogvfwg8v7jup">
                {/* Illustration Area */}
                <div className="h-48 w-full overflow-hidden relative" data-id="element-5097" data-mp="2sg499jzztfpq">
                  {guide.illustration}
                </div>

                {/* Content Area */}
                <div className="p-8 flex flex-col flex-grow" data-id="element-5098" data-mp="3265mthupzfqe">
                  <div className="mb-4" data-id="element-5099" data-mp="3g6zutzduveoj">
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${guide.tagColor}`} data-id="element-5100" data-mp="3g5yhtpda4i46">
                      {guide.tag}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-[#111111] mb-3 group-hover:text-[#631bb7] transition-colors" data-id="element-5101" data-mp="1hrn7xdf2yeid">
                    {guide.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-grow" data-id="element-5102" data-mp="17psyggcr96v7">
                    {guide.description}
                  </p>
                  <div className="flex items-center text-[#631bb7] font-bold text-sm mt-auto" data-id="element-5103" data-mp="xwkib6gkf13s">
                    Read Guide{' '}
                    <ArrowRight size={16} className="ml-1.5 transition-transform group-hover:translate-x-1" data-id="element-5104" data-mp="12uvtbkiljhnl" />
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-5105" data-mp="f0m13kp1enbj" />
    </div>;
}